/**
 * Expired token view
 */
import React from 'react';

// Translation
import translate from '../../translate/Translate';

// Icons
import * as icons from '../../ui/Icons';

const SessionExpired = class SessionExpired extends React.Component {
  componentDidMount() {
    const { UserStore } = this.props.store;

    UserStore.resetUserData();
  }

  render() {
    const { translation } = this.props;

    return (
      <main
        id="main-content"
        className="page wrap"
        tabIndex="-1"
        aria-labelledby="page-title"
      >
        <div className="panel panel--sm panel--solo">
          <i className="panel__icon">
            <icons.clock />
          </i>

          <h1 id="page-title" className="panel__title">
            {translation.heading}
          </h1>

          <p>{translation.body}</p>
        </div>
      </main>
    );
  }
};

export default translate('SessionExpired')(SessionExpired);
